import React from 'react';
import css from './CartIcon.module.css'
import classNames from 'classnames';

export default function CartIcon({ itemsCount = 0, className, isInbox }) {
    return (
        <div className={classNames(css.cartIcon)}>
            {isInbox ?
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM8 10H16V12H8V10Z" fill="black" />
                </svg>
                :
                <svg className={css.icon} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.00488 14V2H0.00488281V0H3.00488C3.55717 0 4.00488 0.44772 4.00488 1V13H16.4433L18.4433 5H6.00488V3H19.7241C20.2764 3 20.7241 3.44772 20.7241 4C20.7241 4.08176 20.7141 4.16322 20.6942 4.24254L18.1942 14.2425C18.083 14.6877 17.683 15 17.2241 15H3.00488C2.4526 15 2.00488 14.5523 2.00488 14ZM4.00488 21C2.90031 21 2.00488 20.1046 2.00488 19C2.00488 17.8954 2.90031 17 4.00488 17C5.10945 17 6.00488 17.8954 6.00488 19C6.00488 20.1046 5.10945 21 4.00488 21ZM16.0049 21C14.9003 21 14.0049 20.1046 14.0049 19C14.0049 17.8954 14.9003 17 16.0049 17C17.1095 17 18.0049 17.8954 18.0049 19C18.0049 20.1046 17.1095 21 16.0049 21Z" fill="black" />
                </svg>}

            <div className={css.itemCountWrapper}><div className={css.countAspectRatio}><span className={css.itemCount}>{itemsCount}</span></div></div>
        </div>
    )
}
